import React, { useEffect, useState } from 'react';
import { clampNumber } from './revenueLeversLogic';

const RevenueLeversNumberField = ({
  label,
  hint,
  note,
  unit,
  value,
  onChange,
  min,
  max,
  step = 1,
  inputClassName = '',
  disabled = false,
}) => {
  const [draft, setDraft] = useState(String(value));
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDraft(String(value));
    }
  }, [value, isFocused]);

  const handleChange = (event) => {
    const raw = event.target.value;

    if (raw === '') {
      setDraft('');
      return;
    }

    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) {
      return;
    }

    setDraft(raw);
    onChange(clampNumber(parsed, min, max));
  };

  const handleFocus = (event) => {
    setIsFocused(true);
    setDraft(String(value));
    event.target.select();
  };

  const handleBlur = () => {
    setIsFocused(false);

    if (draft === '') {
      onChange(min);
      setDraft(String(min));
      return;
    }

    const parsed = clampNumber(draft, min, max);
    onChange(parsed);
    setDraft(String(parsed));
  };

  return (
    <div className="rl-field">
      <div className="rl-field-label">
        <span>{label}</span>
        {hint ? <span className="rl-field-hint">{hint}</span> : null}
      </div>
      <div className="rl-input-wrap">
        <input
          type="number"
          className={`rl-input${inputClassName ? ` ${inputClassName}` : ''}`}
          min={min}
          max={max}
          step={step}
          value={isFocused ? draft : value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
        />
        {unit ? <span className="rl-input-unit">{unit}</span> : null}
      </div>
      {note ? <div className="rl-field-note">{note}</div> : null}
    </div>
  );
};

export default RevenueLeversNumberField;
